import { useMutation } from '~/utils/rq';

import { ForcedExposureCreative } from './useFetchForcedExposureCreatives';

export type UpdateForcedExposurePayload = {
  display_name?: string;
  exposure_type?: string;
  exposure_device?: string;
};

export const useUpsertForcedExposureCreative = (
  campaignId?: string,
  creativeId?: string
) => {
  const url = !!creativeId
    ? `/admin/campaigns/${campaignId}/forced-exposure/creatives/${creativeId}`
    : `/admin/campaigns/${campaignId}/forced-exposure/creatives`;

  const method = !!creativeId ? 'patch' : 'post';

  return useMutation<
    FormData | UpdateForcedExposurePayload,
    ForcedExposureCreative
  >(
    {},
    {
      url,
      method
    }
  );
};

export const useDeleteForcedExposureCreative = (
  campaignId?: string,
  creativeId?: string
) => {
  const url = `/admin/campaigns/${campaignId}/forced-exposure/creatives/${creativeId}`;

  const method = 'delete';

  return useMutation<void, any>(
    {},
    {
      url,
      method
    }
  );
};
